// EKSELENS360 v1.2 brand iconography (8 phase-spine + 12 service-line + 12 value-stream).
// All icons are stroke="currentColor" line marks (24px canvas, 1.75 stroke) — they inherit
// the surrounding text colour, so they adapt to the palette + light/dark automatically.
import { ReactComponent as Discover } from "../assets/ekicons/spine/01-discover.svg";
import { ReactComponent as Diagnose } from "../assets/ekicons/spine/02-diagnose.svg";
import { ReactComponent as Design } from "../assets/ekicons/spine/03-design.svg";
import { ReactComponent as Plan } from "../assets/ekicons/spine/04-plan.svg";
import { ReactComponent as Mobilise } from "../assets/ekicons/spine/05-mobilise.svg";
import { ReactComponent as Deliver } from "../assets/ekicons/spine/06-deliver.svg";
import { ReactComponent as Embed } from "../assets/ekicons/spine/07-embed.svg";
import { ReactComponent as Optimise } from "../assets/ekicons/spine/08-optimise.svg";

import { ReactComponent as Ai360 } from "../assets/ekicons/service-lines/ai360.svg";
import { ReactComponent as Benefits360 } from "../assets/ekicons/service-lines/benefits360.svg";
import { ReactComponent as Capability360 } from "../assets/ekicons/service-lines/capability360.svg";
import { ReactComponent as Change360 } from "../assets/ekicons/service-lines/change360.svg";
import { ReactComponent as Data360 } from "../assets/ekicons/service-lines/data360.svg";
import { ReactComponent as Digital360 } from "../assets/ekicons/service-lines/digital360.svg";
import { ReactComponent as Govern360 } from "../assets/ekicons/service-lines/govern360.svg";
import { ReactComponent as Itsm360 } from "../assets/ekicons/service-lines/itsm360.svg";
import { ReactComponent as Operating360 } from "../assets/ekicons/service-lines/operating360.svg";
import { ReactComponent as Pmo360 } from "../assets/ekicons/service-lines/pmo360.svg";
import { ReactComponent as Stakeholder360 } from "../assets/ekicons/service-lines/stakeholder360.svg";
import { ReactComponent as Supplier360 } from "../assets/ekicons/service-lines/supplier360.svg";

import { ReactComponent as CaptiveFinance } from "../assets/ekicons/value-streams/captive-finance.svg";
import { ReactComponent as EnablingData } from "../assets/ekicons/value-streams/enabling-data.svg";
import { ReactComponent as EnablingIt } from "../assets/ekicons/value-streams/enabling-it.svg";
import { ReactComponent as HireToRetire } from "../assets/ekicons/value-streams/hire-to-retire.svg";
import { ReactComponent as IdeaToMarket } from "../assets/ekicons/value-streams/idea-to-market.svg";
import { ReactComponent as LeadToOrder } from "../assets/ekicons/value-streams/lead-to-order.svg";
import { ReactComponent as OrderToCash } from "../assets/ekicons/value-streams/order-to-cash.svg";
import { ReactComponent as PlanToProduce } from "../assets/ekicons/value-streams/plan-to-produce.svg";
import { ReactComponent as RecordToReport } from "../assets/ekicons/value-streams/record-to-report.svg";
import { ReactComponent as RiskToAssurance } from "../assets/ekicons/value-streams/risk-to-assurance.svg";
import { ReactComponent as SourceToPay } from "../assets/ekicons/value-streams/source-to-pay.svg";
import { ReactComponent as StrategyToExecution } from "../assets/ekicons/value-streams/strategy-to-execution.svg";

const REGISTRY = {
  // phase spine
  "discover": Discover, "diagnose": Diagnose, "design": Design, "plan": Plan,
  "mobilise": Mobilise, "deliver": Deliver, "embed": Embed, "optimise": Optimise,
  // service lines
  "ai360": Ai360, "benefits360": Benefits360, "capability360": Capability360, "change360": Change360,
  "data360": Data360, "digital360": Digital360, "govern360": Govern360, "itsm360": Itsm360,
  "operating360": Operating360, "pmo360": Pmo360, "stakeholder360": Stakeholder360, "supplier360": Supplier360,
  // value streams
  "captive-finance": CaptiveFinance, "enabling-data": EnablingData, "enabling-it": EnablingIt,
  "hire-to-retire": HireToRetire, "idea-to-market": IdeaToMarket, "lead-to-order": LeadToOrder,
  "order-to-cash": OrderToCash, "plan-to-produce": PlanToProduce, "record-to-report": RecordToReport,
  "risk-to-assurance": RiskToAssurance, "source-to-pay": SourceToPay, "strategy-to-execution": StrategyToExecution,
};

export const EK_ICON_NAMES = Object.keys(REGISTRY);

export const EkIcon = ({ name, size, className = "", strokeWidth }) => {
  const Cmp = REGISTRY[name];
  if (!Cmp) return null;
  const dim = size ? { width: size, height: size } : {};
  const style = strokeWidth ? { strokeWidth } : undefined;
  return <Cmp {...dim} className={className} style={style} aria-hidden="true" />;
};

export default EkIcon;
